var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18H5.875C5.64294 18 5.42038 17.9078 5.25628 17.7437C5.09219 17.5796 5 17.3571 5 17.125V14.5C5 14.2679 5.09219 14.0454 5.25628 13.8813C5.42038 13.7172 5.64294 13.625 5.875 13.625V10.125C5.69057 10.1238 5.51123 10.0644 5.3626 9.9552C5.21396 9.84601 5.10362 9.69265 5.04734 9.51702C4.99106 9.34139 4.99171 9.15246 5.04921 8.97722C5.10671 8.80198 5.21811 8.64939 5.3675 8.54124L11.4925 4.16624C11.6407 4.06073 11.8181 4.00403 12 4.00403C12.1819 4.00403 12.3593 4.06073 12.5075 4.16624L18.6325 8.54124C18.7819 8.64939 18.8933 8.80198 18.9508 8.97722C19.0083 9.15246 19.0089 9.34139 18.9527 9.51702C18.8964 9.69265 18.786 9.84601 18.6374 9.9552C18.4888 10.0644 18.3094 10.1238 18.125 10.125V13.625C18.3571 13.625 18.5796 13.7172 18.7437 13.8813C18.9078 14.0454 19 14.2679 19 14.5V17.125C19 17.3571 18.9078 17.5796 18.7437 17.7437C18.5796 17.9078 18.3571 18 18.125 18ZM6.75 16.25H17.25V15.375H6.75V16.25ZM14.625 13.625H16.375V10.125H14.625V13.625ZM11.125 13.625H12.875V10.125H11.125V13.625ZM7.625 13.625H9.375V10.125H7.625V13.625Z",
    fill: "#97B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaosIcon);
export default __webpack_public_path__ + "static/media/daosIcon.5ebec1abe11f8c48089ed099e0d4017a.svg";
export { ForwardRef as ReactComponent };